module.exports = __webpack_public_path__ + "static/img/18078C_1_2_R_20221017_fit.2c11d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18078C_1_2_R_20221017_fit.png
// module id = W5cu
// module chunks = 0